module.exports = __webpack_public_path__ + "img/hotel.b85d9ebd.png";